import React, { useEffect, useStaten, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import Footer from "../../../components/footer/footer";
import Topbar from "../../../components/topbar/topbar";
import { setPathArray } from "../../../reducer/adminSlice";
import { setLoading } from "../../../reducer/auth/auth";
import CustomAccordion from "./customaccordion";

import {
  getMediumProfileDetails,
  changeMediumshipStatus,
  changeSessionPrefrences,
} from "../../../services/admin";
import StarsRating from "stars-rating";
import "./profile.css";
import { isHTML, removeQueryParams, setQueryParams } from "../../../utils/helpers";
const generateSrcDoc = (htmlBody) => `
  <html>
    <head>
    <link rel="stylesheet" href="/fonts/style.css" />
     <style>
        body {
          margin: 0;
          font-family: "Oakes-Grotesk-Medium";
          font-size : 14px;
          color: #555;
        }
      </style>
    </head>
    <body>
      ${htmlBody}
      <script>
        function sendHeight() {
          const height = document.body.scrollHeight;
          parent.postMessage({ type: 'setHeight', height }, '*');
        }
        window.onload = sendHeight;
        window.onresize = sendHeight;
      </script>
    </body>
  </html>
`;

export default function MediumPricingView() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("view");
  const searchVal = searchParams.get("search");
  const searchName = searchParams.get("searchName");
  const searchOprator = searchParams.get("searchOprator");
  const searchFilterOprater = searchParams.get("searchFilterOprater");
  const page = searchParams.get('page');
  const rowperpage = searchParams.get('rowperpage');
  
  //query params
  const [profile, setProfile] = useState(null);
  const [selectValue, setSelectValue] = useState("");
  const [approvedPrefrences, setApprovedPrefrences] = useState([
    { id: 1, name: "Other Mediums", status: false },
    { id: 2, name: "Starter Clients", status: false },
    { id: 3, name: "Outreach Clients", status: false },
    { id: 4, name: "Paying Clients", status: false },
  ]);

  //query state
  const [queryValue, setQueryValue] = useState('');
  const [query1, setQuery1] = useState('');
  const [query2, setQuery2] = useState('');
  const [query3, setQuery3] = useState('');
  const [query4, setQuery4] = useState('');
  const [query5, setQuery5] = useState('');
  const [query6, setQuery6] = useState('');
  const params = useParams();
  const iframeRef = useRef(null);
            const [iframeHeight, setIframeHeight] = useState("100px");
              useEffect(() => {
                const handleMessage = (event) => {
                    if (event.data && event.data.type === "setHeight") {
                        let height =  event.data.height + 65;
                    setIframeHeight(height + "px");
                    }
                };
          
                window.addEventListener("message", handleMessage);
                return () => window.removeEventListener("message", handleMessage);
                }, []);
  

  useEffect(() => {
    localStorage.setItem('pagintionTYPE', 'change')
    dispatch(setPathArray(params.id));
   // getProfile(params.id);


    setQueryParams(setQueryValue, setQuery1, setQuery2,setQuery3,setQuery4,setQuery5,setQuery6, status, searchVal, searchName,page ,rowperpage,searchOprator,searchFilterOprater)
    setTimeout(() => {
      removeQueryParams()

    }, 2000);


    return () => {
      dispatch(setPathArray(null));
    };

  }, []);

  const getProfile = (id) => {
    dispatch(setLoading(true));
    getMediumProfileDetails(id)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          const arraydata = data.data.data;
          if (
            Array.isArray(arraydata.preferences) &&
            arraydata.preferences.length === 0
          )
            arraydata.preferences = {};
          if (
            Array.isArray(arraydata.morePreferences) &&
            arraydata.morePreferences.length === 0
          )
            arraydata.morePreferences = {};
          setProfile(arraydata);
          setSelectValue(arraydata.general.current_mediumship_level);
          setApprovedPrefrences(
            arraydata.preferences.session_preferences !== null
              ? mapObject(arraydata.preferences.session_preferences)
              : approvedPrefrences
          );
        }
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };
  const mapObject = (items) => {
    let array = approvedPrefrences;
    array.map((item) => {
      if (items.includes(item.name)) {
        item.status = true;
      } else {
        item.status = false;
      }
    });
    return array;
  };
  const changeMediumStatus = (value) => {
    let body = {
      userId: params.id,
      mediumship_level: value,
    };
    changeMediumshipStatus(body)
      .then(() => { })
      .catch(() => { });
  };

  const calculateUnique = (arr) => {
    let value = arr.reduce((acc, val) => {
      acc[val] = acc[val] === undefined ? 1 : (acc[val] += 1);
      return acc;
    }, {});
    return value;
  };
  const calculateRating = (feedbacks) => {
    let total = 0;
    let sum_resp = 0;
    let counts = feedbacks.map((item) => {
      return parseInt(JSON.parse(item.feedback).Star_Rating);
    });

    Object.entries(calculateUnique(counts)).map(([key, value]) => {
      sum_resp += parseInt(value) * parseInt(key);
      total += parseInt(value);
    });

    return Math.floor(sum_resp / total);
  };

  const changeHandler = (e, item) => {
    if (e.target.name === "wantToDoSessions") {
      setApprovedPrefrences(
        approvedPrefrences.map((value) => {
          if (parseInt(value.id) === parseInt(item.id)) {
            return {
              ...value,
              ...(value.status = e.target.checked),
            };
          } else {
            return {
              ...value,
            };
          }
        })
      );
      let bodyData = approvedPrefrences
        .filter((item) => {
          if (item.status) {
            return item.name;
          }
        })
        .map((value) => {
          return value.name;
        });
      let body = {
        session_preferences: bodyData,
        user_id: params.id,
      };
      changeSessionPrefrences(body)
        .then(() => { })
        .catch(() => { });
    }
    if (e.target.name === "sel") {
      const value = e.target.value;
      setSelectValue(value);
      changeMediumStatus(value);
    }
  };
  // const checkDefault = (name) => {
  //   if (approvedPrefrences.includes(name)) return true;
  //   if (!approvedPrefrences.includes(name)) return false;
  // };

      const getBio = (info) =>{
        const rawContentFromDB = info
        let html;
      if (!isHTML(rawContentFromDB)) {
        let info =
          rawContentFromDB
            .split("\n")
            .map(line => `${line}`)
            .join("");
        console.log(info, "cejdncjkm");
        html = info
        return info
      }
      else {
console.log( rawContentFromDB,"ckejdnm")
         html = JSON.parse(rawContentFromDB).content
            return <div dangerouslySetInnerHTML={{ __html: JSON.parse(rawContentFromDB).content }} />
      }

  }
   const getInfo = (info) => {
            
      const rawContentFromDB = info
      let html;
      if (!isHTML(rawContentFromDB)) {
          console.log( info,"ckejdnm1")
          let info =
              rawContentFromDB
                  .split("\n")
                  .map(line => `${line}`)
                  .join("");
          console.log(info, "cejdncjkm");
          html = info
          return info
      }
      else {
          // console.log( info,"ckejdnm2")
          // html = JSON.parse(rawContentFromDB).content
          // return <div dangerouslySetInnerHTML={{ __html: rawContentFromDB }} />
          
            html = JSON.parse(rawContentFromDB).content
            const srcDoc = generateSrcDoc(html);
          return srcDoc 
      }
  
  // "{\"content\":\"<p style=\\\"margin-left:0px;\\\">Try a Community Support Group:</p>\\n<ol>\\n<li><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Male Mediums - Ed S. Mediums Who Speak French - Cindy L.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unsupported: Doubt/Fear from Family/Friends = Lisa A.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unity: Group Meditation - Amber K. Healing Session for Mediums - Catherine B.</span></li>\\n</ol>\\n\"}"
  
  }
  return (
    <div className="">
  

      <div className="single-profile-saction">
        <div className="">
          <div className="back-btn-profile">
            <span className="back-handler pointer" onClick={() => status === null ? navigate(-1) : navigate(`/mediums?view=${queryValue}&search=${query1}&searchName=${query2}&page=${query3}&rowperpage=${query4}&pagintion=${'change'}&searchOprator=${query5}&searchFilterOprater=${query6}`)} >
              <img src="../images/arrow-back.png" alt="go back" />
              Go Back
            </span>
          </div>
          <div className="">
              {/* ---------- Pricing Accordion Section ---------- */}
          <div className="container mt-5 mb-5">
           

            {/* Accordion */}
            <CustomAccordion />
          </div>
          </div>
        
        </div>
      </div>
 
    </div>
  );
}
